import api from 'apis/config/api-service';

interface ElkasoUserParams {
  [key: string]: any;
}

// SearchData type not needed; inline types used

interface MasterKeyData {
  [key: string]: any;
}

export default {
  getElkasoUsers: (params?: ElkasoUserParams) => api.get(`users?filter=type||$notin||admin,cms_user&`, { ...params }),
  search: (text: string) => api.post('search', { searchFor: text }),
  getMasterKey: (data: MasterKeyData) => api.post('master-pin', data),
};
